import { deserialize } from 'cerialize'
import { DefaultForm } from 'Pages/ibro'

interface Options {
	isReset?: boolean
	payload?: DefaultForm
}

export class DirectorForm {
	@deserialize public authinn_director: string
	@deserialize public authaddress_director?: any
	@deserialize public authpassport_director: string
	@deserialize public authpassportser_director: string
	@deserialize public authpassportnum_director: string
	@deserialize public authpassportwhogive_director: string
	@deserialize public authpassportdategive_director: string
	@deserialize public authpassportkod_director: string
	@deserialize public authpersoncitizenship_director: string
	@deserialize public authpersondate_director: string
	@deserialize public authpersonplace_director: string
	@deserialize public authposition_director: string

	constructor(options?: Options) {
		if (!options || options.isReset) {
			this.authaddress_director = undefined
			this.authinn_director = undefined
			this.authpersoncitizenship_director = undefined
			this.authpersondate_director = undefined
			this.authpersonplace_director = undefined
			this.authposition_director = undefined
			this.authpassport_director = undefined
			this.authpassportser_director = undefined
			this.authpassportnum_director = undefined
			this.authpassportwhogive_director = undefined
			this.authpassportdategive_director = undefined
			this.authpassportkod_director = undefined
		} else {
			Object.keys(options.payload).forEach((elem) => {
				this[elem.concat('_director')] = options.payload[elem]
			}, this)
		}
	}
}
